/* eslint-disable */





// ─── Verb → Intent Seeds ──────────────────────────────────────────────────────
// Each entry maps a list of trigger tokens to a candidate intent with a base score.
// Scores are additive across rules.








export const VERB_INTENT_SEEDS = [
    // navigate (open list/templates page)
    { tokens: ['open', 'policies'], intent: 'navigate', score: 65, reason: 'verb:open + keyword:policies → navigate list' },
    { tokens: ['go', 'policies'], intent: 'navigate', score: 50, reason: 'verb:go + keyword:policies' },
    { tokens: ['list', 'policies'], intent: 'navigate', score: 75, reason: 'verb:list + keyword:policies → navigate list (boosted)' },
    { tokens: ['browse', 'policies'], intent: 'navigate', score: 30, reason: 'verb:browse + keyword:policies' },
    { tokens: ['open', 'templates'], intent: 'navigate', score: 55, reason: 'verb:open + keyword:templates → navigate templates' },
    { tokens: ['go', 'templates'], intent: 'navigate', score: 35, reason: 'verb:go + keyword:templates' },
    { tokens: ['list', 'templates'], intent: 'navigate', score: 35, reason: 'verb:list + keyword:templates' },
    { tokens: ['show', 'templates'], intent: 'navigate', score: 30, reason: 'verb:show + keyword:templates' },
    { tokens: ['/templates'], intent: 'navigate', score: 95, reason: 'slash command: /templates' },
    { tokens: ['/policies'], intent: 'navigate', score: 95, reason: 'slash command: /policies' },
    { tokens: ['/draft', 'policy'], intent: 'policy_create_from_template', score: 95, reason: 'slash command: /draft policy' },

    // policy_open (open a specific policy)
    { tokens: ['open', 'policy'], intent: 'policy_open', score: 50, reason: 'verb:open + keyword:policy' },
    { tokens: ['view', 'policy'], intent: 'policy_open', score: 60, reason: 'verb:view + keyword:policy' },
    { tokens: ['edit', 'policy'], intent: 'policy_open', score: 60, reason: 'verb:edit + keyword:policy' },
    { tokens: ['update', 'policy'], intent: 'policy_open', score: 60, reason: 'verb:update + keyword:policy' },
    { tokens: ['modify', 'policy'], intent: 'policy_open', score: 55, reason: 'verb:modify + keyword:policy' },
    { tokens: ['go', 'policy'], intent: 'policy_open', score: 35, reason: 'verb:go + keyword:policy' },
    // (no 'show policy' seed: too ambiguous when 'policy' is in a title phrase)

    // policy_search
    { tokens: ['search', 'policies'], intent: 'policy_search', score: 60, reason: 'verb:search + keyword:policies' },
    { tokens: ['find', 'policies'], intent: 'policy_search', score: 55, reason: 'verb:find + keyword:policies' },
    { tokens: ['search', 'policy'], intent: 'policy_search', score: 50, reason: 'verb:search + keyword:policy' },
    { tokens: ['find', 'policy'], intent: 'policy_search', score: 45, reason: 'verb:find + keyword:policy' },
    { tokens: ['have', 'policy'], intent: 'policy_search', score: 40, reason: 'verb:have + keyword:policy' },
    { tokens: ['have', 'policies'], intent: 'policy_search', score: 45, reason: 'verb:have + keyword:policies' },
    { tokens: ['show', 'policies'], intent: 'policy_search', score: 50, reason: 'verb:show + keyword:policies → search intent' },
    { tokens: ['list', 'policies'], intent: 'policy_search', score: 50, reason: 'verb:list + keyword:policies → search intent' },
    { tokens: ['lookup', 'policy'], intent: 'policy_search', score: 45, reason: 'verb:lookup + keyword:policy' },
    { tokens: ['policies', 'expiring'], intent: 'policy_search', score: 50, reason: 'keyword:policies + keyword:expiring → timed search' },
    { tokens: ['policies', 'due'], intent: 'policy_search', score: 45, reason: 'keyword:policies + keyword:due → timed search' },
    { tokens: ['policies', 'expire'], intent: 'policy_search', score: 45, reason: 'keyword:policies + keyword:expire → timed search' },
    { tokens: ['/search'], intent: 'policy_search', score: 95, reason: 'slash command: /search' },
    { tokens: ['/find'], intent: 'policy_search', score: 95, reason: 'slash command: /find' },

    // template_search
    { tokens: ['show', 'templates'], intent: 'template_search', score: 55, reason: 'verb:show + keyword:templates (with query context)' },
    { tokens: ['search', 'templates'], intent: 'template_search', score: 85, reason: 'verb:search + keyword:templates (boosted)' },
    { tokens: ['find', 'templates'], intent: 'template_search', score: 65, reason: 'verb:find + keyword:templates' },
    { tokens: ['list', 'templates'], intent: 'template_search', score: 60, reason: 'verb:list + keyword:templates → search intent' },
    { tokens: ['find', 'template'], intent: 'template_search', score: 60, reason: 'verb:find + keyword:template' },
    { tokens: ['have', 'template'], intent: 'template_search', score: 65, reason: 'verb:have + keyword:template → template search' },
    { tokens: ['have', 'templates'], intent: 'template_search', score: 65, reason: 'verb:have + keyword:templates → template search' },
    { tokens: ['templates', 'for'], intent: 'template_search', score: 75, reason: 'keyword:templates + preposition:for → template search (boosted)' },

    // policy_create_from_template
    { tokens: ['create', 'policy'], intent: 'policy_create_from_template', score: 60, reason: 'verb:create + keyword:policy' },
    { tokens: ['create', 'policies'], intent: 'policy_create_from_template', score: 65, reason: 'verb:create + keyword:policies' },
    { tokens: ['new', 'policy'], intent: 'policy_create_from_template', score: 60, reason: 'verb:new + keyword:policy' },
    { tokens: ['new', 'policies'], intent: 'policy_create_from_template', score: 65, reason: 'verb:new + keyword:policies' },
    { tokens: ['draft', 'policy'], intent: 'policy_create_from_template', score: 60, reason: 'verb:draft + keyword:policy' },
    { tokens: ['draft', 'policies'], intent: 'policy_create_from_template', score: 65, reason: 'verb:draft + keyword:policies' },
    { tokens: ['generate', 'policy'], intent: 'policy_create_from_template', score: 60, reason: 'verb:generate + keyword:policy' },
    { tokens: ['generate', 'policies'], intent: 'policy_create_from_template', score: 65, reason: 'verb:generate + keyword:policies' },
    { tokens: ['create', 'all', 'policies'], intent: 'policy_create_from_template', score: 85, reason: 'batch creation: create all policies' },
    { tokens: ['generate', 'all', 'policies'], intent: 'policy_create_from_template', score: 85, reason: 'batch creation: generate all policies' },
    { tokens: ['create', 'template'], intent: 'policy_create_from_template', score: 40, reason: 'verb:create + keyword:template' },
    { tokens: ['from', 'template'], intent: 'policy_create_from_template', score: 30, reason: 'preposition:from + keyword:template → creation intent' },
    { tokens: ['policy', 'template'], intent: 'policy_create_from_template', score: 15, reason: 'keyword:policy + keyword:template → weak creation hint' },

    // policy_export_pdf
    { tokens: ['export'], intent: 'policy_export_pdf', score: 50, reason: 'verb:export' },
    { tokens: ['pdf'], intent: 'policy_export_pdf', score: 40, reason: 'keyword:pdf' },
    { tokens: ['download'], intent: 'policy_export_pdf', score: 40, reason: 'verb:download' },
    { tokens: ['export', 'pdf'], intent: 'policy_export_pdf', score: 70, reason: 'verb:export + keyword:pdf → strong export match' },
    { tokens: ['download', 'pdf'], intent: 'policy_export_pdf', score: 65, reason: 'verb:download + keyword:pdf → strong export match' },

    // policy_export_batch_pdf
    { tokens: ['export', 'all', 'policies'], intent: 'policy_export_batch_pdf', score: 95, reason: 'batch export: export all policies' },
    { tokens: ['export', 'approved', 'policies'], intent: 'policy_export_batch_pdf', score: 95, reason: 'batch export: export approved policies' },
    { tokens: ['download', 'all', 'policies'], intent: 'policy_export_batch_pdf', score: 90, reason: 'batch export: download all policies' },
    { tokens: ['entire', 'policy', 'library'], intent: 'policy_export_batch_pdf', score: 95, reason: 'batch export: entire policy library' },
    { tokens: ['export', 'entire', 'library'], intent: 'policy_export_batch_pdf', score: 95, reason: 'batch export: entire library' },
    { tokens: ['export', 'policy', 'library'], intent: 'policy_export_batch_pdf', score: 95, reason: 'batch export: policy library' },
    { tokens: ['export', 'zip'], intent: 'policy_export_batch_pdf', score: 90, reason: 'batch export: ZIP format' },
    { tokens: ['download', 'zip'], intent: 'policy_export_batch_pdf', score: 90, reason: 'batch export: download ZIP' },
    { tokens: ['full', 'library'], intent: 'policy_export_batch_pdf', score: 80, reason: 'batch export: full library' },

    // policy_show_acknowledgements
    { tokens: ['acknowledgements'], intent: 'policy_show_acknowledgements', score: 70, reason: 'keyword:acknowledgements' },
    { tokens: ['acknowledgement'], intent: 'policy_show_acknowledgements', score: 70, reason: 'keyword:acknowledgement' },
    { tokens: ['acks'], intent: 'policy_show_acknowledgements', score: 70, reason: 'keyword:acks' },
    { tokens: ['ack'], intent: 'policy_show_acknowledgements', score: 60, reason: 'keyword:ack' },
    { tokens: ['acknowledged'], intent: 'policy_show_acknowledgements', score: 55, reason: 'keyword:acknowledged' },

    // policy_show_approvals
    { tokens: ['show', 'approvals'], intent: 'policy_show_approvals', score: 90, reason: 'verb:show + keyword:approvals → strong match' },
    { tokens: ['show', 'approval'], intent: 'policy_show_approvals', score: 90, reason: 'verb:show + keyword:approval → strong match' },
    { tokens: ['approvals'], intent: 'policy_show_approvals', score: 70, reason: 'keyword:approvals' },
    { tokens: ['approval'], intent: 'policy_show_approvals', score: 70, reason: 'keyword:approval' },
    { tokens: ['approvers'], intent: 'policy_show_approvals', score: 65, reason: 'keyword:approvers' },
    { tokens: ['reviewers'], intent: 'policy_show_approvals', score: 70, reason: 'keyword:reviewers' },
    { tokens: ['approve'], intent: 'policy_show_approvals', score: 55, reason: 'keyword:approve' },

    // policy_show_revision_history
    { tokens: ['revision', 'history'], intent: 'policy_show_revision_history', score: 80, reason: 'keyword:revision + keyword:history → strong match' },
    { tokens: ['revisions'], intent: 'policy_show_revision_history', score: 70, reason: 'keyword:revisions' },
    { tokens: ['versions'], intent: 'policy_show_revision_history', score: 65, reason: 'keyword:versions' },
    { tokens: ['version', 'history'], intent: 'policy_show_revision_history', score: 75, reason: 'keyword:version + keyword:history' },
    { tokens: ['changes'], intent: 'policy_show_revision_history', score: 50, reason: 'keyword:changes' },
    { tokens: ['changelog'], intent: 'policy_show_revision_history', score: 60, reason: 'keyword:changelog' },
    { tokens: ['history'], intent: 'policy_show_revision_history', score: 40, reason: 'keyword:history (weak)' },

    // policy_framework_mapping_view
    { tokens: ['mapped'], intent: 'policy_framework_mapping_view', score: 60, reason: 'keyword:mapped' },
    { tokens: ['mapping'], intent: 'policy_framework_mapping_view', score: 60, reason: 'keyword:mapping' },
    { tokens: ['policies', 'mapped'], intent: 'policy_framework_mapping_view', score: 75, reason: 'keyword:policies + keyword:mapped' },
    { tokens: ['framework', 'mapping'], intent: 'policy_framework_mapping_view', score: 75, reason: 'keyword:framework + keyword:mapping' },
    { tokens: ['control', 'mapping'], intent: 'policy_framework_mapping_view', score: 70, reason: 'keyword:control + keyword:mapping' },
    { tokens: ['controls', 'mapped'], intent: 'policy_framework_mapping_view', score: 70, reason: 'keyword:controls + keyword:mapped' },

    // help
    { tokens: ['help'], intent: 'help', score: 90, reason: 'keyword:help' },
    { tokens: ['?'], intent: 'help', score: 75, reason: 'keyword:?' },
    { tokens: ['assist'], intent: 'help', score: 70, reason: 'keyword:assist' },
    { tokens: ['commands'], intent: 'help', score: 65, reason: 'keyword:commands → help intent' },

    // compliance_readiness_view
    { tokens: ['readiness'], intent: 'compliance_readiness_view', score: 60, reason: 'keyword:readiness' },
    { tokens: ['score'], intent: 'compliance_readiness_view', score: 40, reason: 'keyword:score' },
    { tokens: ['readiness', 'score'], intent: 'compliance_readiness_view', score: 95, reason: 'keywords:readiness + score' },
    { tokens: ['compliance', 'score'], intent: 'compliance_readiness_view', score: 90, reason: 'keywords:compliance + score' },
    { tokens: ['cmmc', 'score'], intent: 'compliance_readiness_view', score: 95, reason: 'keywords:cmmc + score' },
    { tokens: ['cmmc', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'keywords:cmmc + readiness' },
    { tokens: ['cmmc', 'l1', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'explicit CMMC L1 readiness' },
    { tokens: ['cmmc', 'l2', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'explicit CMMC L2 readiness' },
    { tokens: ['cmmc', 'level', '1', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'explicit CMMC Level 1 readiness' },
    { tokens: ['cmmc', 'level', '2', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'explicit CMMC Level 2 readiness' },
    { tokens: ['readiness', 'report'], intent: 'compliance_readiness_view', score: 95, reason: 'keywords:readiness + report' },
    { tokens: ['compliance', 'report'], intent: 'compliance_readiness_view', score: 90, reason: 'keywords:compliance + report' },
    { tokens: ['cmmc', 'report'], intent: 'compliance_readiness_view', score: 95, reason: 'keywords:cmmc + report' },
    { tokens: ['readiness', 'summary'], intent: 'compliance_readiness_view', score: 90, reason: 'keywords:readiness + summary' },
    // audit_logs_view
    { tokens: ['audit'], intent: 'audit_logs_view', score: 90, reason: 'keyword:audit' },
    { tokens: ['logs'], intent: 'audit_logs_view', score: 70, reason: 'keyword:logs' },
    { tokens: ['audit', 'logs'], intent: 'audit_logs_view', score: 95, reason: 'keyword:audit + logs' },
    { tokens: ['/audit'], intent: 'audit_logs_view', score: 95, reason: 'slash command: /audit' },

    // new UI command matches
    { tokens: ['show', 'readiness'], intent: 'compliance_readiness_view', score: 95, reason: 'UI command: Show readiness' },
    { tokens: ['view', 'gaps'], intent: 'compliance_gaps_view', score: 95, reason: 'UI command: View gaps' },
    { tokens: ['generate', 'report'], intent: 'compliance_report_generate', score: 90, reason: 'UI command: Generate report' },
    { tokens: ['view', 'policies'], intent: 'navigate', score: 95, reason: 'UI command: View policies' },

    // ── MVP Slash Commands ───────────────────────────────────────────────────────
    // /readiness → compliance_readiness_view (deterministic)
    { tokens: ['/readiness'], intent: 'compliance_readiness_view', score: 98, reason: 'slash /readiness' },
    { tokens: ['/readiness', 'cmmc'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness CMMC' },
    { tokens: ['/readiness', 'cmmc', 'l1'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness CMMC L1' },
    { tokens: ['/readiness', 'cmmc', 'level', '1'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness CMMC Level 1' },
    { tokens: ['/readiness', 'cmmc', 'l2'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness CMMC L2' },
    { tokens: ['/readiness', 'cmmc', 'level', '2'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness CMMC Level 2' },
    { tokens: ['/readiness', 'nist'], intent: 'compliance_readiness_view', score: 99, reason: 'slash /readiness NIST' },

    // /control-info → compliance_control_view (deterministic)
    { tokens: ['/control-info'], intent: 'compliance_control_view', score: 98, reason: 'slash /control-info' },
    { tokens: ['view', 'control'], intent: 'compliance_control_view', score: 75, reason: 'view control' },
    { tokens: ['show', 'control'], intent: 'compliance_control_view', score: 70, reason: 'show control' },
    { tokens: ['explain', 'control'], intent: 'compliance_control_view', score: 70, reason: 'explain control → deterministic' },

    // /gaps → compliance_gaps_view (deterministic)
    { tokens: ['/gaps'], intent: 'compliance_gaps_view', score: 98, reason: 'slash /gaps' },
    { tokens: ['/gaps', 'cmmc'], intent: 'compliance_gaps_view', score: 99, reason: 'slash /gaps CMMC' },
    { tokens: ['show', 'gaps'], intent: 'compliance_gaps_view', score: 90, reason: 'show gaps' },
    { tokens: ['view', 'gaps'], intent: 'compliance_gaps_view', score: 90, reason: 'view gaps' },
    { tokens: ['missing', 'controls'], intent: 'compliance_gaps_view', score: 88, reason: 'missing controls → gaps' },
    { tokens: ['gaps'], intent: 'compliance_gaps_view', score: 70, reason: 'keyword: gaps' },

    // /report → compliance_report_generate (deterministic)
    { tokens: ['/report'], intent: 'compliance_report_generate', score: 98, reason: 'slash /report' },
    { tokens: ['/report', 'cmmc'], intent: 'compliance_report_generate', score: 99, reason: 'slash /report CMMC' },
    { tokens: ['/report', 'cmmc', 'l1'], intent: 'compliance_report_generate', score: 99, reason: 'slash /report CMMC L1' },
    { tokens: ['compliance', 'report'], intent: 'compliance_report_generate', score: 85, reason: 'compliance report' },
    { tokens: ['generate', 'compliance', 'report'], intent: 'compliance_report_generate', score: 95, reason: 'generate compliance report' },

    // /policies → navigate (deterministic)
    { tokens: ['/policies'], intent: 'navigate', score: 98, reason: 'slash /policies' },
    { tokens: ['/policy'], intent: 'policy_open', score: 98, reason: 'slash /policy → open specific policy' },

    // /search → policy_search (can escalate to AI for broad queries)
    { tokens: ['/search', 'policies'], intent: 'policy_search', score: 97, reason: 'slash /search policies' },
    { tokens: ['/search', 'controls'], intent: 'compliance_control_view', score: 90, reason: 'slash /search controls' },
    { tokens: ['/search'], intent: 'policy_search', score: 90, reason: 'slash /search (default to policy search)' },

    // /summarize → ESCALATE_TO_LAYER2 (AI required)
    // handled by OPEN_ENDED_PATTERNS — no seed needed here

    // /draft → policy_create_from_template (or AI)
    { tokens: ['/draft'], intent: 'policy_create_from_template', score: 95, reason: 'slash /draft (no subject → template picker)' },
];


// ─── Single-token boosts (applied individually) ───────────────────────────────
// Tokens that, when present alone, boost scores for specific intents








export const SINGLE_TOKEN_BOOSTS = [
    { token: 'search', intent: 'policy_search', score: 20, reason: 'verb:search present' },
    { token: 'find', intent: 'policy_search', score: 15, reason: 'verb:find present' },
    { token: 'show', intent: 'policy_search', score: 10, reason: 'verb:show present' },
    { token: 'list', intent: 'policy_search', score: 15, reason: 'verb:list present' },
    { token: 'open', intent: 'policy_open', score: 15, reason: 'verb:open present' },
    { token: 'view', intent: 'policy_open', score: 20, reason: 'verb:view present' },
    { token: 'edit', intent: 'policy_open', score: 20, reason: 'verb:edit present' },
    { token: 'update', intent: 'policy_open', score: 20, reason: 'verb:update present' },
    { token: 'modify', intent: 'policy_open', score: 20, reason: 'verb:modify present' },
    { token: 'export', intent: 'policy_export_pdf', score: 20, reason: 'verb:export present' },
    { token: 'help', intent: 'help', score: 30, reason: 'strong keyword:help' },
    { token: 'create', intent: 'policy_create_from_template', score: 15, reason: 'verb:create present' },
    { token: 'draft', intent: 'policy_create_from_template', score: 15, reason: 'verb:draft present' },
    { token: 'new', intent: 'policy_create_from_template', score: 15, reason: 'keyword:new present' },
    { token: 'template', intent: 'policy_create_from_template', score: 10, reason: 'keyword:template present' },
    { token: 'have', intent: 'template_search', score: 15, reason: 'verb:have present → template search hint' },
    { token: 'mapping', intent: 'policy_framework_mapping_view', score: 20, reason: 'keyword:mapping present' },
    { token: 'mapped', intent: 'policy_framework_mapping_view', score: 20, reason: 'keyword:mapped present' },
    { token: 'reviewers', intent: 'policy_show_approvals', score: 25, reason: 'keyword:reviewers present' },
    { token: 'approvers', intent: 'policy_show_approvals', score: 25, reason: 'keyword:approvers present' },
    { token: 'policies', intent: 'navigate', score: 20, reason: 'keyword:policies present → navigate hint' },
    { token: 'templates', intent: 'navigate', score: 15, reason: 'keyword:templates present → navigate hint' },
    { token: 'template', intent: 'template_search', score: 10, reason: 'keyword:template → template search hint' },
    { token: 'audit', intent: 'audit_logs_view', score: 25, reason: 'keyword:audit present' },
    // compliance command boosts
    { token: 'gaps', intent: 'compliance_gaps_view', score: 30, reason: 'keyword:gaps present' },
    { token: 'readiness', intent: 'compliance_readiness_view', score: 25, reason: 'keyword:readiness present' },
    { token: 'report', intent: 'compliance_report_generate', score: 20, reason: 'keyword:report present' },
    { token: 'control', intent: 'compliance_control_view', score: 15, reason: 'keyword:control present' },
    { token: 'control-info', intent: 'compliance_control_view', score: 30, reason: 'keyword:control-info present' },
    { token: 'missing', intent: 'compliance_gaps_view', score: 20, reason: 'keyword:missing → gaps hint' },
];


// ─── Framework Synonyms → Canonical IDs ──────────────────────────────────────
// Each entry: { synonyms, canonical, requireBothTokens? }
// requireBothTokens: true means BOTH token[0] AND token[1] must appear.







export const FRAMEWORK_SYNONYMS = [
    {
        synonyms: [
            ['cmmc', 'l1'], ['cmmc', 'level', '1'], ['cmmc', '2.0', 'l1'],
            ['cmmc', 'level1'], ['cmmc1']
        ],
        canonical: 'CMMC_L1',
        requireAll: true,
    },
    {
        synonyms: [
            ['cmmc', 'l2'], ['cmmc', 'level', '2'], ['cmmc', '2.0', 'l2'],
            ['cmmc', 'level2'], ['cmmc2']
        ],
        canonical: 'CMMC_L2',
        requireAll: true,
    },
    {
        // "cmmc" alone without level → use separate CMMC_L1 + CMMC_L2 via ambiguity logic
        synonyms: [['cmmc']],
        canonical: 'CMMC_L1',  // default hint; ambiguity checked by extractor
        requireAll: false,
    },
    {
        synonyms: [
            ['nist', '800', '171'], ['nist', '171'], ['sp', '800', '171'],
            ['nist800171'], ['800-171'], ['nist-800-171']
        ],
        canonical: 'NIST_800_171',
        requireAll: true,
    },
    {
        synonyms: [
            ['iso', '27001'], ['iso27001'], ['iso', '27001:2022'],
            ['annex', 'a'],   // common ISO 27001 reference
        ],
        canonical: 'ISO_27001',
        requireAll: true,
    },
    {
        synonyms: [
            ['soc2'], ['soc', '2'], ['soc', 'ii'],
        ],
        canonical: 'SOC2',
        requireAll: true,
    },
    {
        synonyms: [
            ['pci', 'dss'], ['pcidss'], ['pci'],
        ],
        canonical: 'PCI_DSS',
        requireAll: false,
    },
];

// ─── Time Phrase Map ──────────────────────────────────────────────────────────






export const TIME_PHRASE_MAP = [
    {
        patterns: [/\bnext\s+month\b/i],
        extract: () => ({ kind: 'relative', unit: 'month', value: 1 }),
    },
    {
        patterns: [/\bthis\s+month\b/i],
        extract: () => ({ kind: 'relative', unit: 'month', value: 0 }),
    },
    {
        patterns: [/\blast\s+month\b/i],
        extract: () => ({ kind: 'relative', unit: 'month', value: -1 }),
    },
    {
        patterns: [/\bnext\s+(\d+)\s+days?\b/i],
        extract: (m) => ({ kind: 'relative', unit: 'day', value: parseInt(m[1], 10) }),
    },
    {
        patterns: [/\blast\s+(\d+)\s+days?\b/i],
        extract: (m) => ({ kind: 'relative', unit: 'day', value: -parseInt(m[1], 10) }),
    },
    {
        patterns: [/\bnext\s+(\d+)\s+weeks?\b/i],
        extract: (m) => ({ kind: 'relative', unit: 'week', value: parseInt(m[1], 10) }),
    },
    {
        patterns: [/\bthis\s+week\b/i],
        extract: () => ({ kind: 'relative', unit: 'week', value: 0 }),
    },
    {
        patterns: [/\bnext\s+week\b/i],
        extract: () => ({ kind: 'relative', unit: 'week', value: 1 }),
    },
    {
        patterns: [/\bin\s+(\d+)\s+weeks?\b/i],
        extract: (m) => ({ kind: 'relative', unit: 'week', value: parseInt(m[1], 10) }),
    },
    {
        patterns: [/\bin\s+(\d+)\s+days?\b/i],
        extract: (m) => ({ kind: 'relative', unit: 'day', value: parseInt(m[1], 10) }),
    },
    {
        patterns: [/\bthis\s+quarter\b/i],
        extract: () => ({ kind: 'relative', unit: 'quarter', value: 0 }),
    },
    {
        patterns: [/\bnext\s+quarter\b/i],
        extract: () => ({ kind: 'relative', unit: 'quarter', value: 1 }),
    },
];

// ─── Open-Ended Question Patterns → Escalate ─────────────────────────────────
// Any input matching these is immediately flagged OPEN_ENDED_QUESTION

export const OPEN_ENDED_PATTERNS = [
    /^\s*how\b/i,
    /^\s*why\b/i,
    /\bshould\s+i\b/i,
    /\bis\s+(it|our|this|the)\b/i,
    /\bare\s+(we|our)\b/i,
    /\banalyze\b/i,
    /\banalysis\b/i,
    /\bsummarize\b/i,
    /\bsummarise\b/i,
    /\bhow\s+(good|well|compliant|ready|mature)\b/i,
    /\bwhat.{0,20}risk\b/i,
    /\bam\s+i\b/i,
    /\bcan\s+you\s+(explain|tell|help)\b/i,
    /\bwhat\s+should\b/i,
    /\badvice\b/i,
    /\brecommend\b/i,
    /\bassess\b/i,
    /\bevaluate\b/i,
    /\bexplain\s+(why|how|what|the)\b/i,
    /^\/explain\b/i,
    /^\/summarize\b/i,
    /^\/summarise\b/i,
];

// ─── Route Context Bias Rules ─────────────────────────────────────────────────
// When on a specific route, certain intents get score boosts.






export const ROUTE_CONTEXT_BIAS = [
    {
        routePattern: /\/policies\/[^/]+/,  // policy detail route (has ID segment)
        intentBoosts: [
            { intent: 'policy_export_pdf', boost: 30, reason: 'context: already on policy detail → export boost' },
            { intent: 'policy_show_acknowledgements', boost: 25, reason: 'context: already on policy detail → acks boost' },
            { intent: 'policy_show_approvals', boost: 25, reason: 'context: already on policy detail → approvals boost' },
            { intent: 'policy_show_revision_history', boost: 25, reason: 'context: already on policy detail → revisions boost' },
        ],
    },
    {
        routePattern: /\/policies(\?|$)/,  // policies list
        intentBoosts: [
            { intent: 'policy_search', boost: 20, reason: 'context: on policy list → search boost' },
        ],
    },
    {
        routePattern: /\/templates/,
        intentBoosts: [
            { intent: 'template_search', boost: 20, reason: 'context: on templates → template search boost' },
            { intent: 'policy_create_from_template', boost: 15, reason: 'context: on templates → create boost' },
        ],
    },
];

// ─── Action Target Names (canonical) ─────────────────────────────────────────

export const ACTION_TARGETS = {
    POLICY_LIST: 'policy.list',
    POLICY_DETAIL: 'policy.detail',
    POLICY_TEMPLATES: 'policy.templates',
    POLICY_CREATE_FROM_TEMPLATE: 'policy.create_from_template',
    POLICY_EXPORT_PDF: 'policy.export_pdf',
    POLICY_EXPORT_BATCH_PDF: 'policy.export_batch_pdf',
    POLICY_ACKNOWLEDGEMENTS: 'policy.acknowledgements',
    POLICY_APPROVALS: 'policy.approvals',
    POLICY_REVISION_HISTORY: 'policy.revision_history',
    POLICY_MAPPINGS: 'policy.mappings',
    COMPLIANCE_READINESS: 'compliance.readiness',
    COMPLIANCE_GAPS: 'compliance.gaps',
    COMPLIANCE_CONTROL: 'compliance.control',
    COMPLIANCE_REPORT: 'compliance.report',
    AUDIT_LOGS: 'audit.logs',
};


// ─── Escalation suggested prompts by intent ───────────────────────────────────

export const SUGGESTED_PROMPTS = {
    OPEN_ENDED_QUESTION: [
        'Show me policies expiring next month',
        'Search policies for access control',
        'Open policy P-1023',
    ],
    UNKNOWN_INTENT: [
        'Open policies',
        'Help',
        'Search policies for [topic]',
    ],
    LOW_CONFIDENCE: [
        'Try being more specific, e.g. "export policy P-1023 pdf"',
        'Try "search policies for [keyword]"',
        'Try "show acknowledgements for P-1023"',
    ],
    AMBIGUOUS_FRAMEWORK: [
        'Specify the framework, e.g. "CMMC L1 AC.L1-3.1.1"',
        'Try "policies mapped to NIST 13.1.2"',
    ],
    MISSING_REQUIRED_ENTITY: [
        'Include a policy ID, e.g. "export policy P-1023 pdf"',
        'Navigate to a policy first, then type "export pdf"',
    ],
    AMBIGUOUS_COMMAND: [
        'Search policies for "visitor log"',
        'Open policy P-123',
        'Go to policies list',
    ],
};
